export default __webpack_public_path__ + "static/media/biaoji2.156f514b.svg";